import React, { useState, useEffect, useCallback } from 'react';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import api from '../../../api';

import FileListItem from './FileListItem';

function MaterialUploadModal(props) {
    const { t } = useTranslation();
    const { show, onHide, organizationID, eventID, partnerID, materialFolderType, callback } = props;

    const [ uploading, setUploading ] = useState(false);
    const [ files, setFiles ] = useState([]);

    // Clear files when modal is closed
    useEffect(() => {
        if(!show && files.length > 0) {
            setFiles([]);
        }
    }, [show, files])


    /**
     * Dropzone configuration
     */
    const onDrop = useCallback(acceptedFiles => {
        const newFiles = acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file),
            isNew: true
        }))
        setFiles([...files].concat(newFiles));
    }, [files]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});


    /**
     * Upload selected files.
     */
    const _uploadFiles = () => {
        let filesToUpload = [...files].filter(file => !file.status);

        if(!filesToUpload.length) {
            return;
        }

        setUploading(true);

        filesToUpload.forEach((file, index) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('name', file.name);
            formData.append('isPublic', true);
            formData.append('organizationID', organizationID);
            formData.append('eventID', eventID);
            if(partnerID) {
                formData.append('partnerID', partnerID);
            }
            formData.append('materialFolderType', materialFolderType);
            api.material.upload(formData).then(response => {
                if(!response || !response.data || !response.data.data || !response.data.data.material) {
                    throw new Error('Unexpected error');
                }
                if(callback) {
                    callback(response.data.data.material);
                    file.status = 'success';
                }
            }).catch(error => {
                file.status = 'error';
            }).finally(() => {
                if(index === (files.length-1)) {
                    // setFiles([]);
                    setFiles(filesToUpload);
                }
                setUploading(false);
            });
        });
    }


    /**
     *
     * @param {int} index
     */
    const _handleRemoveFile = index => {
        let newFiles = [...files];
        newFiles.splice(index, 1);
        setFiles(newFiles);
    }


    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('general.upload_files')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div {...getRootProps()} className="DropzoneWrapper cursor-pointer">
                    <input {...getInputProps()} />
                    {
                        isDragActive ?
                        <span>{t('general.drop_file_here')}</span> :
                        <span>{t('general.drag_and_drop_1')}<span className="text-primary" style={{ cursor: 'pointer' }}> {t('general.drag_and_drop_2')}</span></span>
                    }
                </div>
                {files.length > 0 ?
                    <table className="table table-striped" style={{ width: '100%', fontSize: '13px' }}>
                        <thead>
                            <tr>
                                <th>{t('general.file')}</th>
                                <th>{t('general.status')}</th>
                                <th style={{ width: '80px' }}>{t('general.delete')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {files.map((file, index) => (
                                <FileListItem
                                    key={index}
                                    file={file}
                                    onRemove={() => _handleRemoveFile(index)}
                                />
                            ))}
                        </tbody>
                    </table>
                : null}
            </Modal.Body>
            <Modal.Footer>
                {uploading ?
                    <Spinner animation="border" variant="primary" className="float-left" />
                : null}
                <Button type="button" variant="light" onClick={onHide} disabled={uploading}>{t('general.close')}</Button>
                <Button type="button" variant="primary" onClick={_uploadFiles} disabled={(uploading || files.length === 0)}>{t('general.send_files')}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MaterialUploadModal;